module.exports = __webpack_public_path__ + "img/success.c2d54674.png";